"use strict";
/*!
 APA Spine

 All Rights Reserved
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("./namespace"));
require("./jquery");
require("./controller");
require("./data");
require("./debug");
require("./events");
require("./formatting");
require("./init");
require("./language");
require("./loader");
require("./model");
require("./observer");
require("./params");
require("./progress");
require("./setup");
require("./url");
require("./utils");
require("./view");
window.apa = namespace_1.default;
window.japa = jquery_1.default;
exports.default = namespace_1.default;
